import { render, staticRenderFns } from "./Indicators.vue?vue&type=template&id=0a5d8180&scoped=true&"
import script from "./Indicators.vue?vue&type=script&lang=js&"
export * from "./Indicators.vue?vue&type=script&lang=js&"
import style0 from "./Indicators.vue?vue&type=style&index=0&id=0a5d8180&prod&lang=scss&scoped=true&"
import style1 from "./Indicators.vue?vue&type=style&index=1&id=0a5d8180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d8180",
  null
  
)

export default component.exports